import { useRouter } from 'next/router';
import {
  ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { useState } from 'react';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { toNumber } from 'lodash';
import { DEFAULT_DISTANCE } from 'lib/constants';
import { FilterPopover } from 'components/FilterPopover';

interface Props {
  defaultDistance?: number;
}

export const DistanceSelect = ({ defaultDistance = DEFAULT_DISTANCE }: Props) => {
  const router = useRouter();

  const [distance, setDistance] = useState(toNumber(router.query.distance || defaultDistance));

  const onApply = () => {
    updateRouterQuery(router, { distance: distance.toString() });
  };

  const toggleDistanceButton = (d: number) => (
    <ToggleButton value={d} aria-label={`${d} miles`} size="small">
      {d}
      {' '}
      miles
    </ToggleButton>
  );

  return (
    <div className="ml-1">
      <FilterPopover
        title={`< ${distance} miles`}
        onApply={onApply}
        clearable={false}
      >
        <div className="p-4 w-full">
          <ToggleButtonGroup
            value={distance}
            onChange={(e, v: number) => setDistance(v)}
            aria-label="creator search distance"
            exclusive
          >
            {toggleDistanceButton(25)}
            {toggleDistanceButton(100)}
            {toggleDistanceButton(200)}
          </ToggleButtonGroup>
        </div>
      </FilterPopover>
    </div>
  );
};
